const ko = {
  meta: {
    brand: '(주)에스앤케이이엔지',
    description: '발전소의 안정적이고 효율적인 운영에 필수적인 전기·전자 기계, 부품 및 계측기기 분야의 전문 공급 기업',
  },

  common: {
    skipToContent: '본문으로 건너뛰기',
    scrollToTop: '맨 위로 이동',
    toggleMenu: '메뉴 토글',
    scroll: '스크롤',
    toggleThemeLight: '라이트 모드로 전환',
    toggleThemeDark: '다크 모드로 전환',
    toggleLangKo: '한국어로 보기',
    toggleLangEn: 'Switch to English',
  },

  nav: {
    mainMenuLabel: '주 메뉴',
    mobileMenuLabel: '모바일 메뉴',
    about: '기업소개',
    business: '사업영역',
    projects: '주요 납품 실적',
    hr: '인재채용',
    center: '고객센터',
    home: '홈으로 이동',
  },

  footer: {
    address: '경기도 안산시 단원구 신촌5길 28',
    tel: 'TEL: 070-8270-0665',
    fax: 'FAX: 031-502-0220',
    email: 'sk5559611@hanmail.net',
    hours: '평일 09:00 – 18:00 (점심 12:00 – 13:00)',
    description:
      '(주)에스앤케이이엔지는 고품질 자동화 시스템 및 계측기기 솔루션 공급업체로서, 국내외 주요 기업들에게 최고의 제품과 서비스를 제공합니다.',
    about: '기업소개',
    aboutLinks: {
      company: '회사소개',
      history: '연혁',
      awards: '수상내역',
      certification: '품질인증',
      location: '오시는 길',
      transport: '교통안내',
    },
    business: '사업영역',
    businessLinks: {
      overview: '사업영역',
      partners: '주요 파트너사',
      delivery: '납품 현황',
      power: '주요 전기 기계·장비',
      control: '제어 시스템 및 전자 부품',
      instruments: '계측기기 및 시험 장비',
      materials: '관련 기자재 및 부품',
      projects: '주요 납품 실적',
    },
    hr: '인재채용',
    hrLinks: { talent: '인재상', process: '채용 프로세스' },
    center: '고객센터',
    centerLinks: { support: '고객지원', faq: '자주 묻는 질문' },
    copyright: (year) => `© ${year} (주)에스앤케이이엔지. All Rights Reserved.`,
    business_info: '사업자등록번호: 134-87-13658 | 대표: 최재민 | 개인정보관리책임자: 박용수',
  },

  home: {
    hero: {
      eyebrow: 'Since 1999 · 발전소 엔지니어링 파트너',
      title: '(주)에스앤케이이엔지',
      subtitle: '전기·전자 기자재 전문 공급 파트너',
      description:
        '(주)에스앤케이이엔지는 두온시스템(주) 발전소 대리점입니다. 다년간의 경험과 전문성을 바탕으로 신뢰할 수 있는 공급 파트너가 되겠습니다.',
      primaryCta: '사업영역 보기',
      secondaryCta: '문의하기',
    },
    business: {
      eyebrow: 'Business',
      title: '사업영역',
      subtitle: '발전소의 안정적이고 효율적인 운영에 필요한 전기·전자 핵심 솔루션을 공급합니다.',
      cards: [
        {
          title: '주요 전기 기계·장비',
          description:
            '발전소의 안정적인 전력 생산 및 공급에 필수적인 변압기, 차단기, 보호 계전기 등 고품질의 핵심 전기 기계 및 장비를 공급합니다.',
        },
        {
          title: '제어 시스템 및 전자 부품',
          description:
            '발전 설비의 정밀 제어 및 자동화 시스템 구축에 필요한 PLC, 센서, 제어 모듈 등 다양한 고성능 전자 부품 및 시스템 솔루션을 제공합니다.',
        },
        {
          title: '계측기기 및 시험 장비',
          description:
            '설비 상태의 정확한 측정, 진단 및 감시를 위한 전압/전류계, 온도/압력계 등 신뢰성 높은 산업용 계측기기와 시험 장비를 공급합니다.',
        },
        {
          title: '관련 기자재 및 부품',
          description:
            '케이블, 커넥터, 배관 자재, 예비 부품 등 발전소 운영 및 유지보수에 필요한 다양한 종류의 고품질 관련 기자재와 소모품을 취급합니다.',
        },
      ],
    },
  },

  about: {
    banner: {
      eyebrow: 'About Us',
      title: '기업소개',
      description: '(주)에스앤케이이엔지는 발전소 설비 운영에 필수적인 전기·전자 기자재를 공급합니다.',
    },
    companyTitle: '회사소개',
    companyEyebrow: 'Company',
    companyLead:
      '(주)에스앤케이이엔지는 [strong]두온시스템(주) 발전소 대리점[/strong]으로, 발전소 설비 운영에 필요한 핵심 전기·전자 기자재를 공급합니다.',
    docs: {
      license: '사업자 등록증',
      sme: '중소기업 확인서 (소상공인)',
    },
    historyTitle: '연혁',
    historyEyebrow: 'History',
    yearSuffix: '년',
    awardsTitle: '수상 내역',
    awardsEyebrow: 'Awards',
    awards: [
      {
        title: '한국중부발전 인천화력본부 감사패',
        lines: [
          '기력 1, 2호기 터빈 취약설비 보강을 위한 부품 납품 및 설비 운영 기여',
          '한국중부발전㈜ 인천화력본부는 에스앤케이이엔지의 탁월한 기술력과 신속한 대응으로 설비 안전성 향상 및 발전소 안정적 운영에 기여한 공로를 인정하여 감사패를 수여하였습니다.',
        ],
        date: '2013년 11월 29일',
      },
      {
        title: '한국동서발전(주) 실증참여확인서',
        lines: [
          '배관 압력 전송기 국산화 주도 및 발전 설비 국산화 실증 완료',
          '한국동서발전(주)는 에스앤케이이엔지가 수행한 배관 압력 전송기 국산화 개발 및 실증 사업에 참여하여 국내 발전소 설비 국산화에 기여한 성과를 인정하여 실증참여확인서를 발급하였습니다.',
        ],
        date: '2020년 11월 27일',
      },
    ],
    certTitle: '품질 인증',
    certEyebrow: 'Certification',
    certLead: '국제 표준화 기구(ISO)의 품질 경영 시스템 인증을 획득하여, 제품과 서비스의 일관된 품질을 보장합니다.',
    certs: [
      {
        title: 'ISO 9001:2008 / KS Q ISO 9001:2009 인증',
        desc: '품질경영시스템 국제 표준 인증. 제품 및 서비스의 국제 품질 표준 준수를 인증받아 고객에게 일관된 품질의 제품과 서비스를 제공합니다.',
        meta: '인증기관: 한국표준협회(ITS) · 인증번호: ITS-KQ-00563',
      },
      {
        title: 'ISO 9001:2008 / KS Q ISO 9001:2009 Certificate',
        desc: 'International Standard for Quality Management Systems. Certified to provide consistent quality products and services according to international standards.',
        meta: 'Certification Body: ITS · Certificate No: ITS-KQ-00563',
      },
    ],
    locationTitle: '오시는 길',
    locationEyebrow: 'Location',
    address: {
      heading: '주소',
      line1: '경기 안산시 단원구 신촌5길 28 (우) 15443',
      line2: 'Tel : 070-8270-0665 · E-mail : sk5559611@hanmail.net',
      line3: '근무시간 : 평일 09:00 – 18:00 (토·일·공휴일 휴무)',
    },
    transportTitle: '교통 안내',
    transportEyebrow: 'Transport',
    transport: [
      { title: '자가용', lines: ['서해안고속도로 안산 IC → 15분 소요', '사내 주차장 무료 이용 가능'] },
      { title: '버스',   lines: ['안산역/안산터미널 정류장 하차', '123 · 456번 버스 → ‘신촌사거리’ 하차 → 도보 5분'] },
      { title: '지하철', lines: ['4호선 안산역 2번 출구 → 도보 15분', '또는 123 · 456번 버스 환승 후 ‘신촌사거리’ 하차'] },
    ],
    mapTitle: '에스앤케이이엔지 오시는 길',
  },

  business: {
    banner: {
      eyebrow: 'Business',
      title: '사업영역',
      description: '발전소 설비 운영 전반에 필요한 전기·전자 솔루션을 통합적으로 공급합니다.',
    },
    partnersTitle: '주요 파트너사',
    partnersEyebrow: 'Partners',
    partnersLead:
      '(주)에스앤케이이엔지는 국내외 발전사를 비롯한 다양한 전력 기업과 긴밀한 협력 관계를 유지하며 신뢰를 쌓아왔습니다.',
    deliveryTitle: '파트너사 납품 현황',
    deliveryEyebrow: 'Deliveries',
    deliveryLead: '당사가 공급한 물량을 파트너사 비율로 환산한 수치입니다 (총 100 기준).',
    areasTitle: '(주)에스앤케이이엔지의 사업영역',
    areasEyebrow: 'Areas',
    areasLead:
      '발전소 핵심 설비부터 제어·계측 솔루션까지 통합적으로 공급하여 고객의 안정적 전력 생산을 지원합니다.',
    areas: [
      {
        title: '주요 전기 기계·장비',
        description:
          '세계적 제조사와 파트너십을 통해 고신뢰 발전기·변압기·스위치기어 등을 공급, 무중단 운영과 효율 향상에 기여합니다.',
        items: ['발전기 및 터빈 설비', '고/저압 변압기·리액터', 'GIS·스위치기어', '보호 계전 시스템', 'UPS 및 축전지'],
      },
      {
        title: '제어 시스템 및 전자 부품',
        description: 'DCS·PLC·HMI 및 산업용 센서, 액추에이터를 통해 플랜트 자동화·지능화를 지원합니다.',
        items: ['DCS, PLC, HMI', '온도·압력·유량 센서', '제어 밸브·액추에이터', '인버터·드라이브', '산업용 네트워크 장비'],
      },
      {
        title: '계측기기 및 시험 장비',
        description: '정밀 계측·진단 장비를 제공하여 예방 정비와 설비 신뢰성 향상을 지원합니다.',
        items: ['전력 분석기·품질 측정기', '절연/접지 저항계', '공정 계측기 (T/P/F 등)', '진동 분석기', '휴대용 시험 장비'],
      },
      {
        title: '관련 기자재 및 부품',
        description: '케이블·커넥터·밸브 등 소모성 부품까지 안정적 공급망으로 즉시 지원합니다.',
        items: ['전력·제어·광 케이블', '커넥터·배선 자재', '배관 밸브·피팅', '필터·베어링', '공구·안전장비'],
      },
    ],
  },

  projects: {
    banner: {
      eyebrow: 'Projects',
      title: '주요 납품 실적',
      description: '국내 주요 발전소 및 산업 현장에 공급한 계측·제어 솔루션의 대표 사례입니다.',
    },
    highlightsTitle: '프로젝트 이력',
    highlightsEyebrow: 'Highlights',
    highlightsLead:
      '(주)에스앤케이이엔지는 국내 주요 발전소 및 산업 현장에 고품질의 계측·제어 장비를 공급하며 맞춤형 솔루션을 제공합니다.',
    contractsTitle: '계약 이력',
    contractsEyebrow: 'Contracts',
    contractsLead: '2007년부터 현재까지 국내 주요 발전소 및 산업 현장에 납품한 제품의 상세 계약 이력입니다.',
    specsLabels: { feature: '제품 특성', application: '적용 분야' },
    featured: [
      {
        title: '고정밀 압력 전송기 공급',
        description: '고진공 환경 및 고열 조건에서 안정적인 성능을 제공하는 맞춤형 설계 제품',
        items: ['Absolute Pressure Transmitter APT3200-A — 570EA', 'Flow Transmitter (Differential Pressure Type) APT3500-D — 30EA'],
        specs: [
          { label: '제품 특성', value: '고진공 고열 환경 내성 설계로 극한 환경에서도 안정 성능 유지' },
          { label: '적용 분야', value: '진공 시스템 제어 및 유량 정밀 측정' },
        ],
        tags: ['압력 전송기', '유량 측정', '고진공', '고열 환경'],
      },
      {
        title: '특수 환경용 정밀 압력 전송기',
        description: '방사선 및 전자기 간섭이 있는 극한 환경에서도 정확한 측정이 가능한 고신뢰성 전송기',
        items: ['Absolute Pressure Transmitter APT3200-A', 'Differential Transmitter APT3100-D'],
        specs: [
          { label: '제품 특성', value: '고진공 · 방사선 · 전자기 내성 설계 기반' },
          { label: '적용 분야', value: '원자력 발전소, 의료 방사선 시설, 고정밀 공정 제어' },
        ],
        tags: ['정밀 측정', '방사선 내성', '전자기 차폐', '극한 환경'],
      },
      {
        title: '초고온·고압용 절대압 전송기',
        description: '600°C 초고온 및 최대 50bar 고압 환경에서도 안정적 성능을 제공',
        items: ['Absolute Pressure Transmitter APT3200-A'],
        specs: [
          { label: '제품 특성', value: '온도 최대 600°C · 압력 최대 50 bar 대응' },
          { label: '적용 분야', value: '진공 시스템 제어 · 유량 정밀 측정' },
        ],
        tags: ['초고온', '고압', '절대압 전송기', '진공 제어'],
      },
      {
        title: 'e-fuel 파일럿 플랜트',
        description: '수소와 이산화탄소를 활용한 그린 메탄 생산을 위한 고정밀 압력 측정 솔루션',
        items: ['Absolute Pressure Transmitter APT3200-G'],
        specs: [
          { label: '제품 특성', value: 'H₂ + CO₂ → Green Methane 공정에 최적화' },
          { label: '적용 분야', value: '진공 시스템 · 유량 · 합성연료 생산공정' },
        ],
        tags: ['그린 메탄', 'e-fuel', '수소', '탄소중립'],
      },
      {
        title: '리튬이온 2차전지 LIELSORT 라인',
        description: '배터리 셀 제조 공정에 최적화된 고정밀 압력 측정 및 제어 시스템',
        items: ['Absolute Pressure Transmitter ALT6210', 'Pressure Transmitter APT3200-LED, APT3100-LEC'],
        specs: [
          { label: '제품 특성', value: '고진공·고열 환경 내성, 600°C · 50 bar 대응' },
          { label: '적용 분야', value: '전극 코팅 · 전해질 주입 · 셀 활성화' },
        ],
        tags: ['2차전지', '리튬이온', '배터리 생산', '고진공 공정'],
      },
      {
        title: '발전기 응용 시스템',
        description: '발전 설비 주변 장치에 최적화된 고정밀 압력 측정 솔루션',
        items: ['Absolute Pressure Transmitter APT3100-G'],
        specs: [
          { label: '제품 특성', value: '장기간 연속 운전 환경에서 높은 신뢰성' },
          { label: '적용 분야', value: '터빈 압력 모니터링 · 냉각시스템 제어' },
        ],
        tags: ['발전 설비', '터빈 제어', '고정밀 측정', '시스템 안정성'],
      },
    ],
    table: {
      year: '연도',
      client: '발주처',
      items: '주요 품명',
      scale: '규모',
      empty: '검색 결과가 없습니다.',
      disclaimer: '※ 발주처 정보는 비식별화하여 표기하였습니다.',
    },
    scaleLabels: { small: '소형', medium: '중형', large: '대형' },
    filters: { all: '전체', utility_a: '발전사 A', utility_b: '발전사 B', utility_c: '발전사 C', utility_d: '발전사 D', other: '기타' },
    clientBuckets: {
      utility_a: '국내 발전사 A',
      utility_b: '국내 발전사 B',
      utility_c: '국내 발전사 C',
      utility_d: '국내 발전사 D',
      public: '에너지 공기업',
      ipp: '민간 발전사',
    },
  },

  hr: {
    banner: {
      eyebrow: 'Careers',
      title: '인재채용',
      description: '열정적이고 도전적인 인재, 전문성과 협업 역량을 갖춘 인재를 찾습니다.',
    },
    talentTitle: '인재상',
    talentEyebrow: 'People',
    talentLead:
      '(주)에스앤케이이엔지는 열정적이고 도전적인 인재, 창의적이고 혁신적인 사고를 가진 인재, 전문성과 글로벌 역량을 갖춘 인재를 소중히 여깁니다.',
    talents: [
      {
        title: '창의적 인재',
        description:
          '기존의 틀에서 벗어나 새로운 관점으로 문제를 바라보고, 혁신적인 아이디어를 도출하며 지속적인 변화와 발전을 추구합니다.',
      },
      {
        title: '전문적 인재',
        description:
          '자신의 분야에서 최고의 전문성을 추구하고, 끊임없는 학습과 자기계발을 통해 역량을 강화하며 글로벌 시장에서 경쟁력을 갖춘 인재입니다.',
      },
      {
        title: '협력적 인재',
        description:
          '다양한 배경과 관점을 존중하며 조직 내외부와 원활하게 소통하고, 시너지를 창출할 수 있는 협업 역량을 갖춘 인재입니다.',
      },
    ],
    processTitle: '채용 프로세스',
    processEyebrow: 'Process',
    processLead: '공정하고 투명한 채용 프로세스를 통해 우수한 인재를 선발합니다.',
    steps: [
      { title: '서류전형',  description: '지원서 및 자기소개서 검토' },
      { title: '1차 면접', description: '실무진 면접 (직무역량 평가)' },
      { title: '2차 면접', description: '임원진 면접 (종합역량 평가)' },
      { title: '최종합격', description: '신체검사 및 입사' },
    ],
  },

  center: {
    banner: {
      eyebrow: 'Support',
      title: '고객센터',
      description: '제품 문의, 기술 지원, 협력업체 등록 등 다양한 문의를 받고 있습니다.',
    },
    supportTitle: '고객지원',
    supportEyebrow: 'Support',
    support: [
      {
        title: '전화 문의',
        text: '기술 지원 및 제품 문의는 전화로 빠르게 도움을 받으실 수 있습니다. 평일 09:00–18:00 운영.',
        label: '070-8270-0665',
      },
      {
        title: '이메일 문의',
        text: '상세한 문의사항은 이메일로 보내주시면 영업일 기준 24시간 이내에 답변드립니다.',
        label: 'sk5559611@hanmail.net',
      },
      {
        title: '기술 지원',
        text: '제품 설치 및 유지보수 관련 기술 지원이 필요하신 경우 기술지원팀으로 문의해주세요.',
        label: '기술지원 요청하기',
      },
    ],
    helpTitle: '자주 묻는 질문 / 문의하기',
    helpEyebrow: 'Help',
    tabs: { faq: 'FAQ', contact: '문의하기' },
    faqs: [
      {
        q: '제품 구매 절차는 어떻게 되나요?',
        a: '제품 구매를 원하시면 전화(070-8270-0665) 또는 이메일(sk5559611@hanmail.net)로 문의해 주시기 바랍니다. 담당 영업 담당자가 제품 사양, 가격, 납기 등에 대해 상세히 안내해 드립니다. 대량 구매 및 지속적인 거래를 원하시는 기업의 경우 별도의 계약을 통해 진행됩니다.',
      },
      {
        q: '기술 교육 및 제품 사용 교육을 받을 수 있나요?',
        a: '네, 제품 구매 고객을 대상으로 제품 사용법 및 유지보수 교육을 제공합니다. 온라인·오프라인 모두 진행하며, 고객사 요청 시 방문 교육도 가능합니다. 교육 일정 및 비용은 고객센터를 통해 문의해 주시기 바랍니다.',
      },
      {
        q: '협력업체로 등록하려면 어떻게 해야 하나요?',
        a: '협력업체 등록 신청서, 사업자등록증, 회사소개서를 이메일(sk5559611@hanmail.net)로 제출해 주시면 내부 심사를 거쳐 약 2주 내로 결과를 안내드립니다.',
      },
      {
        q: '제품 배송은 어떻게 진행되나요?',
        a: '주문 확인 및 결제 완료 후 영업일 기준 3–5일 내에 출고됩니다. 대형·특수 제품의 경우 별도의 배송 일정이 적용될 수 있으며, 전문 물류업체를 통해 진행되고 필요 시 설치 서비스가 함께 제공됩니다.',
      },
    ],
    form: {
      name: '이름 *',
      namePh: '이름을 입력하세요',
      email: '이메일 *',
      emailPh: '이메일을 입력하세요',
      phone: '전화번호 *',
      phonePh: '전화번호를 입력하세요',
      company: '회사명',
      companyPh: '회사명을 입력하세요',
      type: '문의 유형 *',
      typePh: '문의 유형을 선택하세요',
      types: {
        product: '제품 문의',
        technical: '기술 지원',
        warranty: '보증/A/S',
        partnership: '협력업체 등록',
        order: '주문/배송',
        other: '기타',
      },
      model: '제품 모델',
      modelPh: '문의하시는 제품 모델명',
      subject: '제목 *',
      subjectPh: '제목을 입력하세요',
      message: '문의 내용 *',
      messagePh: '문의 내용을 상세히 기재해 주세요',
      file: '첨부파일',
      fileHint: '최대 10MB (jpg, png, pdf, doc, docx)',
      submit: '문의하기',
    },
    info: {
      address: '주소',
      addressValue: '경기 안산시 단원구 신촌5길 28',
      phone: '전화',
      phoneValue: '070-8270-0665',
      email: '이메일',
      emailValue: 'sk5559611@hanmail.net',
    },
  },

  location: {
    banner: {
      eyebrow: 'Contact',
      title: '오시는 길',
      description: '안산 본사 위치와 교통 안내입니다.',
    },
    visitTitle: '찾아오시는 방법',
    visitEyebrow: 'Visit',
    address: {
      heading: '주소',
      lines: [
        '경기 안산시 단원구 신촌5길 28',
        '우편번호: 15443',
        '전화: 070-8270-0665',
        '이메일: sk5559611@hanmail.net',
        '영업시간: 평일 09:00 – 18:00',
        '토·일·공휴일 휴무',
      ],
    },
    transportTitle: '교통 안내',
    transportEyebrow: 'Transport',
    transport: [
      { title: '자가용 이용 시', lines: ['서해안고속도로 안산 IC에서 15분', '주차장 무료 이용 가능'] },
      { title: '버스 이용 시',   lines: ['안산역/안산터미널 정류장 하차', '123 · 456번 버스 이용', '‘신촌사거리’ 하차 후 도보 5분'] },
      { title: '지하철 이용 시', lines: ['4호선 안산역 하차', '2번 출구에서 도보 15분', '또는 123 · 456번 버스 환승'] },
    ],
    mapTitle: '에스앤케이이엔지 오시는 길',
  },
};

export default ko;
